//add color and bar padding properties
import { CommonSchemaIds } from "./common.const.js";
import { FrequencyPlotConfigurationSchemaIds, FrequencyPlotConfigurationTags } from "./configuration.const.js";
export const FREQUENCY_PLOT_CONFIGURATION_TLMD_SCHEMAS = {
    [FrequencyPlotConfigurationSchemaIds.FREQUENCY_PLOT_CONFIGURATION]: {
        id: FrequencyPlotConfigurationSchemaIds.FREQUENCY_PLOT_CONFIGURATION,
        schema: {
            unevaluatedProperties: false
        },
        properties: {
            visible: {
                ref: CommonSchemaIds.VISIBLE,
                required: true,
                usage: [{ tag: FrequencyPlotConfigurationTags.DEFAULT }]
            },
            interval: {
                ref: CommonSchemaIds.INTERVAL,
                required: true,
                usage: [{ tag: FrequencyPlotConfigurationTags.DEFAULT }]
            }
        }
    }
};
